import contractHttpRequestInstance from '../http_requests/contract/contract_http_requests';
import ContractEntity from '../entities/contract/contract_entity';
import Contract from '../presentation_models/contract/contract';
import INewContractRequestBody from "../interfaces/inew_contract_request_body";

const createNewContract = (
   requestBody: INewContractRequestBody,
   observer: {
      receiveContractInfo: Function,
      receiveContractError: Function
   }
) => {
   contractHttpRequestInstance.create(requestBody, {
      success:(contractEntity: ContractEntity) => {
         observer.receiveContractInfo(new Contract(contractEntity.toObject()));
      },
      failure: (error: any) => {
         observer.receiveContractError(error);
      }
   });
}

export default createNewContract;
